'use client';

import React, { useState } from 'react';
import { Send } from 'lucide-react';

export default function ContactForm() {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('Sending...');

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setStatus('Message Sent!');
        setFormData({ name: '', email: '', subject: '', message: '' });
        if (window.fbq) window.fbq('track', 'Contact');
      } else {
        setStatus('Error sending message.');
      }
    } catch (error) {
      setStatus('Something went wrong.');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = "w-full bg-[#1a1a1a] border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#faaf40] outline-none";

  return (
    <div className="bg-[#0a0a0a] p-8 rounded-3xl border border-white/5 relative">
      <h2 className="text-2xl font-bold uppercase mb-6">Send a Message</h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        <input type="text" name="name" value={formData.name} onChange={handleChange} required className={inputStyle} placeholder="FULL NAME" />
        <input type="email" name="email" value={formData.email} onChange={handleChange} required className={inputStyle} placeholder="EMAIL" />
        <textarea name="message" rows="4" value={formData.message} onChange={handleChange} required className={inputStyle} placeholder="YOUR MESSAGE"></textarea>
        
        <button type="submit" disabled={loading} className="w-full bg-[#faaf40] text-black font-bold py-4 rounded-lg flex items-center justify-center gap-2">
          {loading ? 'Sending...' : 'Send Message'} <Send size={18} />
        </button>

        {status && <p className="text-center mt-4 text-sm">{status}</p>}
      </form>
    </div>
  );
}